import { useMemo } from 'react';
import { useRouter } from 'next/router';

import { Log, useUBL } from '@common/log-manager';
import {
  convertProductItemListToUxGoodsCardItemList,
  ImageBannerListComponentType,
  useEnvConfig,
} from '@domains/storehome-common';

interface Params {
  log?: Partial<Log>;
  product_list: ImageBannerListComponentType['product_list'];
}

export const useImageBannerListService = ({ log, product_list }: Params) => {
  const { is_zigzag } = useEnvConfig();
  const tracker = useUBL();
  const router = useRouter();

  const product_card_list = useMemo(
    () =>
      convertProductItemListToUxGoodsCardItemList({
        item_list: product_list,
        is_zigzag,
        show_ranking: false,
      }),
    [is_zigzag, product_list],
  );

  const moveToCollectionPage = (
    event: React.MouseEvent,
    action_button: ImageBannerListComponentType['action_button'],
    landing_url: ImageBannerListComponentType['landing_url'],
  ) => {
    event.stopPropagation();

    let link_url = '';

    if (!action_button && !landing_url) {
      return;
    }

    if (landing_url) {
      link_url = landing_url;
    }

    if (action_button?.link_url) {
      link_url = action_button.link_url;
    }

    // 일단 앱 랜딩을 통해 처리하기로 하고 아래의 코드 주석처리(https://croquis.atlassian.net/browse/SELFE-1565). by lucas
    const match = /.+url=(.+)/.exec(link_url);

    if (!match) {
      return;
    }

    const collection_detail_url = match[1];

    if (log != null) {
      tracker({
        navigation: '',
        ...log,
        category: 'click',
        object_type: 'button',
        object_id: 'see_more',
      });
    }

    if (!collection_detail_url) {
      return;
    }

    if (is_zigzag) {
      return router.push(collection_detail_url);
    }

    return router.push(collection_detail_url.replace('store.', ''));
  };

  return {
    moveToCollectionPage,
    product_card_list,
  };
};
